
import React from 'react';
import { GoogleMap, useJsApiLoader, Marker, InfoWindow } from '@react-google-maps/api';
import { configureStreetViewPanorama, getStreetViewMapOptions } from 'utils/streetView';

const containerStyle = {
  width: '100%',
  height: '100%'
};

function MapGoogle2({ latitudeCenter, longitudeCenter, redirect, zoom, title }) {
  const center = { lat: latitudeCenter, lng: longitudeCenter };
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: import.meta.env.VITE_REACT_APP_GOOGLE_MAPS_API_KEY || '',
    language: 'es',
    region: 'ES',
    version: 'weekly'
  });
  const [map, setMap] = React.useState(null);
  const [showInfoWindow, setShowInfoWindow] = React.useState(false);
  const [activeMarker, setActiveMarker] = React.useState(null);

  const onLoad = React.useCallback(function callback(map) {
    setMap(map);
    configureStreetViewPanorama(map);
  }, []);

  const handleMarkerClick = () => {
    setActiveMarker(null);
    setShowInfoWindow(true);
  };

  const onCloseClick = () => {
    setShowInfoWindow(false);
  };

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  return isLoaded ? (
    <div style={{ width: '100%', height: '100%' }}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={zoom}
        onLoad={onLoad}
        onUnmount={onUnmount}
        options={getStreetViewMapOptions()}
      >
        <Marker
          position={center}
          onClick={handleMarkerClick}
        />
        {showInfoWindow && activeMarker && (
          <InfoWindow
            position={center}
            onCloseClick={onCloseClick}
            options={{ maxWidth: 200 }}
          >
            <div className="info-window">
              <p>{title}</p>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  ) : null;
}

export default MapGoogle2;





